import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CommonDataService } from './common-data.service';
import { GraphqlService } from './graphql.service';
import { LoginService } from './Login.service';
import { SessionService } from './Session.service';

@Injectable({
  providedIn: 'root'
})
export class ClearSessionsService implements CanActivate {

  constructor(private router: Router, private graphQlService: GraphqlService, private commonDataService: CommonDataService, private loginService: LoginService, private sessionService: SessionService) { }
  canActivate(): boolean {
    const obj = {
      crumbData: [],
      menuData: []
    }
    localStorage.removeItem("archiveVersionInput");
    localStorage.removeItem("leftNavigationMenu"); 
    localStorage.removeItem("paragraphNum");
    localStorage.removeItem("publpageId");
    localStorage.removeItem("publicationId");
    localStorage.removeItem("xbrlElementName");
    sessionStorage.removeItem("asc_displayAllSources");
    sessionStorage.removeItem('inPageScrollPositionRetentionData');
    sessionStorage.removeItem('inPageScrollCurrentNum');
    sessionStorage.removeItem('inPageScrollLastUrl');
    this.commonDataService.navData.next(obj);
    this.commonDataService.acceptCookie.next(false);
    this.sessionService.assignUserInfo(null);
    forkJoin([
      this.loginService.deleteSession(),
      this.graphQlService.setCookie(false),
      this.graphQlService.SetPendingContentAgreementSession(false)
    ]).subscribe(() => { this.router.navigate(['/Login']); })
    return false;
  }
}
